// extracted by mini-css-extract-plugin
export default {"container":"style_container__eZ2aV","pageLogo":"style_pageLogo__8C66P"};